export default __webpack_public_path__ + "static/media/work-10.074652ae.jpg";